import * as v from 'valibot'
import { indicationSchema } from '../types'

const authorableIndicationSchema = v.pick(indicationSchema, [
  'id',
  'name',
  'type',
  'description',
  'age',
  'ageMin',
  'ageMinUom',
  'ageMax',
  'ageMaxUom',
  'dosingSummary',
  'dosingSummary_json',
  'patientAttribute',
  'patientAttributeValue',
  'icd10Codes',
  'hcpcsCodes',
  'maxDailyHcpcsUnits',
  'frequencyMaxAdminDays',
  'frequencyMaxFrequency',
  'frequencyTimePeriod',
  'maxUnitsOverTimeMaxHCPCSUnits',
  'maxUnitsOverHcpcsMaxFrequency',
  'maxUnitsOverHcpcsTimePeriod',
])

export const addedIndicationSchema = v.strictObject({
  ...authorableIndicationSchema.entries,
  id: v.pipe(indicationSchema.entries.id, v.trim(), v.nonEmpty()),
  name: v.pipe(indicationSchema.entries.name, v.trim(), v.nonEmpty()),
})
